import {createSlice} from '@reduxjs/toolkit'

export interface Solicitation {
  id: number
  name: string
  email: string
  phone: string
  status: 'pending' | 'approved' | 'rejected'
  createdAt: string
  bio?: string
  avatar?: string
  currentType: 'Gold' | 'Free' | 'VIP' | 'Fremium' | 'Premium'
  requestedType: 'Gold' | 'Free' | 'VIP' | 'Fremium' | 'Premium'
}

interface SolicitationState {
  solicitations: Solicitation[]
  selectedSolicitation: Solicitation | null
  isLoading: boolean
}

const initialState: SolicitationState = {
  solicitations: [],
  selectedSolicitation: null,
  isLoading: false,
}

const solicitationSlice = createSlice({
  name: 'solicitation',
  initialState,
  reducers: {
    setSolicitations: (state, action) => {
      state.solicitations = action.payload
    },
    setSelectedSolicitation: (state, action) => {
      state.selectedSolicitation = action.payload
    },
    approveSolicitation: (state, action) => {
      const solicitation = state.solicitations.find((s) => s.id === action.payload)
      if (solicitation) {
        solicitation.status = 'approved'
      }
    },
    rejectSolicitation: (state, action) => {
      const solicitation = state.solicitations.find((s) => s.id === action.payload)
      if (solicitation) {
        solicitation.status = 'rejected'
      }
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
  },
})

export const {setSolicitations, setSelectedSolicitation, approveSolicitation, rejectSolicitation, setLoading} =
  solicitationSlice.actions

export default solicitationSlice.reducer